import { Group } from "@mantine/core";

const MantineGroup = (props: any) => {
    const {
        children,
        style,
        wrap,
        gap,
        justify,
        align,
        className
    } = props;
    return (
        <Group
            className={className}
            wrap={wrap}
            styles={style}
            gap={gap}
            justify={justify}
            align={align}
        >
            {children}
        </Group>
    );
};

export default MantineGroup;